// src/components/Hero/Hero.jsx
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import ContactForm from '../ContactForm/ContactForm';
import './hero.css';

// Import Desktop Images
import heroImg1 from '../../assets/hero1.png';
import heroImg2 from '../../assets/hero2.webp';
import heroImg3 from '../../assets/hero3.webp';

// Import Mobile Images
import heroMob1 from '../../assets/heromob1.png';
import heroMob2 from '../../assets/heromob2.png';
import heroMob3 from '../../assets/heromob3.png';

import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  // State to track window width
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Update state on resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Choose images based on screen size
  const desktopImages = [heroImg1, heroImg2, heroImg3];
  const mobileImages = [heroMob1, heroMob2, heroMob3];

  const images = isMobile ? mobileImages : desktopImages;

  const heroContent = [
    {
      heading: "Building Quality Through <br /> Industrial Innovation",
      subheading: "PRECISION METAL STAMPING & IN-HOUSE TOOLING EXCELLENCE",
      description: "DYNAMIC STAMPING PVT. LTD. IS AN ISO 9001:2015 & IATF 16949:2016 CERTIFIED AUTOMOTIVE COMPONENT MANUFACTURER, DELIVERING HIGH-PRECISION STAMPED PARTS, SUB-ASSEMBLIES & PLASTIC MOULDED COMPONENTS. SUPPORTED BY A FULLY EQUIPPED IN-HOUSE TOOL ROOM, ROBOTIC WELDING, AND ADVANCED MANUFACTURING FACILITIES.",
      trustedText: "TRUSTED PARTNER TO OEMS & TIER-1 SUPPLIERS SINCE 2005"
    },
    {
      heading: "Advanced Manufacturing Backed <br /> by Engineering Expertise",
      subheading: "HIGH-CAPACITY STAMPING, ROBOTIC WELDING & QUALITY ASSURANCE",
      description: "WITH HIGH-TONNAGE STAMPING PRESSES, IN-HOUSE TOOL DESIGN, AND AUTOMATED WELDING SYSTEMS, DYNAMIC STAMPING DELIVERS SCALABLE AUTOMOTIVE MANUFACTURING SOLUTIONS. OUR STRUCTURED PROCESSES AND CERTIFIED QUALITY SYSTEMS ENSURE CONSISTENT PERFORMANCE AND LONG-TERM RELIABILITY FOR OEM AND TIER-1 PARTNERS.",
      trustedText: "CERTIFIED MANUFACTURING EXCELLENCE | ISO 9001 & IATF 16949"
    },
    {
      heading: "Reliable Automotive Manufacturing <br /> for Global OEM Standards",
      subheading: "STRUCTURED PROCESSES. CERTIFIED SYSTEMS. CONSISTENT PERFORMANCE.",
      description: "DYNAMIC STAMPING PVT. LTD. PARTNERS WITH OEMS AND TIER-1 SUPPLIERS TO DELIVER PRECISION AUTOMOTIVE COMPONENTS WITH STRICT QUALITY CONTROL AND PROCESS DISCIPLINE. OUR INTEGRATED MANUFACTURING SETUP ENSURES SCALABILITY, REPEATABILITY, AND LONG-TERM PROGRAM SUPPORT.",
      trustedText: "ENGINEERED FOR QUALITY, BUILT FOR LONG-TERM PARTNERSHIPS."
    }
  ];

  const [currentImgIndex, setCurrentImgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImgIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <section className={`hero-section ${isMobile ? '' : 'mx-5 mx-lg-4 rounded-5'}`}>

      {/* Background Images */}
      {images.map((img, index) => (
        <div
          key={index}
          className={`hero-bg-image ${index === currentImgIndex ? 'active' : ''}`}
          style={{ backgroundImage: `url(${img})` }}
        ></div>
      ))}

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Content */}
      <div
        key={currentImgIndex}
        className="hero-content text-start text-white hero-content-animate"
      >

        {/* Heading */}
        <h1
          className="hero-heading mb-3"
          dangerouslySetInnerHTML={{ __html: heroContent[currentImgIndex].heading }}
        />

        {/* Subheading */}
        <h5 className="hero-subheading mb-4">
          {heroContent[currentImgIndex].subheading}
        </h5>

        {/* Description */}
        <p className="hero-description mb-4">
          {heroContent[currentImgIndex].description}
        </p>

        {/* Trusted Partner Text */}
        <p className="hero-trusted-text mb-4">
          {heroContent[currentImgIndex].trustedText}
        </p>

        {/* Buttons Container */}
        <div className="hero-buttons-container justify-content-start">
          <button
            className="hero-btn-primary"
            onClick={handleShow}
          >
            Get A Quote
          </button>

          <button
            className="hero-btn-light"
            onClick={() => navigate('/capabilities')}
          >
            Explore Our Capabilities
          </button>
        </div>
      </div>

      {/* Get Quote Modal */}
      <Modal show={showModal} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton style={{ position: 'absolute', right: '1rem', top: '1rem', zIndex: 10, border: 'none' }}>
        </Modal.Header>
        <Modal.Body className="p-0">
          <ContactForm title="Get A Quote" showDescription={false} />
        </Modal.Body>
      </Modal>

      {/* Dots (Desktop Only via CSS) */}
      <div className="dots-container">
        {images.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentImgIndex ? 'active-dot' : ''}`}
            onClick={() => setCurrentImgIndex(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default Hero;